module.exports = __webpack_public_path__ + "img/img8.960e88ab.webp";